<template>
	<div class="container-fluid mt-4">
		<h1>Subscription Management</h1>
		<android-subscription v-if="isAndroid" />
		<i-o-s-subscription v-else-if="isIOS" />
		<web-subscription v-else />
		<glass-card>
			<pricing />
		</glass-card>
	</div>
</template>

<script setup>
	import { computed } from "vue"
	import AndroidSubscription from "@/components/AndroidSubscription.vue"
	import IOSSubscription from "@/components/IOSSubscription.vue"
	import WebSubscription from "@/components/WebSubscription.vue"
	import { Capacitor } from "@capacitor/core"
	import Pricing from "@/components/Pricing.vue"
	import GlassCard from "@/components/GlassCard.vue"

	const isAndroid = computed(() => {
		return Capacitor.getPlatform() === "android"
	})

	const isIOS = computed(() => {
		return Capacitor.getPlatform() === "ios"
	})
</script>

<style lang="less" scoped></style>
